import { UseFormReturnType } from "@mantine/form";
import { LooseKeys, PathValue } from "@mantine/form/lib/paths.types";
import { useFormSubscription } from "shared/hooks/useFormSubscription";

export function useFormState<V, K extends LooseKeys<V>>(
    form: UseFormReturnType<V>,
    k: K,
): [value: PathValue<V, K>, setter: (value: PathValue<V, K>) => unknown] {
    const v = useFormSubscription(form, k);
    return [v as PathValue<V, K>, (v: PathValue<V, K>) => form.setFieldValue(k, v)];
}
